import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Index from '../features/dashboard';
import AppErrorTest from '../features/testErrors/AppErrorTest';
import NotFound from '../common/components/router/NotFound';
import PrivateRoute from '../common/components/router/PrivateRoute';
import LocationAppRoutes from './routes/LocationAppRoutes';
import BookingAppRoutes from './routes/BookingAppRoutes';
import UserAppRoutes from './routes/UserAppRoutes';
import CustomerAppRoutes from './routes/CustomerAppRoutes';
import AccommodationAppRoutes from './routes/AccommodationAppRoutes';
import RateAppRoutes from './routes/RateAppRoutes';
import FeedbackAppRoutes from './routes/FeedbackAppRoutes';
import SettingAppRoutes from './routes/SettingAppRoutes';
import AccountingAppRoutes from './routes/AccountingAppRoutes';
import CartAppRoutes from './routes/CartAppRoutes';

const AppRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <PrivateRoute>
          <Index />
        </PrivateRoute>
      }
    />
    <Route path="/users/*" element={<UserAppRoutes />} />
    <Route path="/customers/*" element={<CustomerAppRoutes />} />
    <Route path="/accommodations/*" element={<AccommodationAppRoutes />} />
    <Route path="/rates/*" element={<RateAppRoutes />} />
    <Route path="/feedbacks/*" element={<FeedbackAppRoutes />} />
    <Route path="/settings/*" element={<SettingAppRoutes />} />
    <Route path="/locations/*" element={<LocationAppRoutes />} />
    <Route path="/accounting/*" element={<AccountingAppRoutes />} />
    <Route path="/bookings/*" element={<BookingAppRoutes />} />
    <Route path="/cart/*" element={<CartAppRoutes />} />
    <Route path="/app-error" element={<AppErrorTest foo="foo" />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
